import * as types from 'stores/types/';

export function updateNotifications( data ) {
  return { type: types.UPDATE_NOTIFICATIONS, data };
}

export function deleteNotification( id ) {
  return { type: types.DELETE_NOTIFICATION, id };
}

export function deleteAllNotifications() {
  return { type: types.DELETE_ALL_NOTIFICATIONS };
}




// WEBPACK FOOTER //
// ./stores/actions/common/notifications.js